<template>
    <div>
        <div
            v-if="journeyLoaded"
            class="overflow-hidden">
            <div
                v-if="findRoute && allocationStatus !== -1"
                class="flex justify-end mb-3">
                <hts-form-button
                    :loading="btnFindRoute.loading"
                    color="info"
                    type="button"
                    :outline="false"
                    @click="handleFindRoute">
                    Cập nhật tuyến
                </hts-form-button>
            </div>
            <div class="flex w-full h-full overflow-hidden gap-2 mb-2">
                <div class="w-1/2 max-h-[800px] flex flex-col">
                    <div class="space-x-2 flex-none items-start align-top">
                        <driver-info :drivers="cDriver" />
                        <vehicle-info :vehicles="[vehicle]" />
                    </div>

                    <travel-route-info
                        class="flex-1"
                        :journey="journey"
                        :editable="editable"
                        @open-planning="openPlanning"
                        @open-timing="openTiming"
                        @open-change-vehicle="openChangeVehicle"
                        @open-change-vehicle-and-mooc="openChangeVehicleAndMooc"
                        @show-trip="handlShowTrip" />
                </div>
                <div class="w-1/2 max-h-[800px]">
                    <div
                        v-show="visibleMap"
                        class="h-[400px]">
                        <hts-map-route
                            ref="travelMap"
                            center-marker
                            :route="markers"
                            :route-separated="routes"
                            :draggable="false"
                            :direction-color="directionColor"
                            :show-location="showLocation"
                            :lat-lng-location-routes="CLatLngLocationRoutes" />
                    </div>
                    <div class="flex items-center">
                        <hts-ui-tabs
                            v-model="tab"
                            class="flex-1"
                            :tabs="tabs" />
                        <div class="flex-none flex items-center max-w-32 min-h-5 justify-end gap-3">
                            <hts-map-icon-map store-key="monitoringOwner" />
                            <hts-map-icon-location store-key="monitoringOwner" />
                        </div>
                    </div>
                    <div
                        class="overflow-auto pr-1"
                        :class="{ 'max-h-[360px]': visibleMap, 'max-h-[760px]': !visibleMap }">
                        <div v-if="tab === 'alerts'">
                            <journey-alerts
                                ref="journeyAlertRef"
                                :journey="journey" />
                        </div>
                        <div v-if="tab === 'files'">
                            <journey-files
                                :journey-id="journey?._id"
                                :editable="editable" />
                        </div>
                    </div>
                </div>
            </div>

            <hts-modal
                v-model="visiblePlanning"
                size="large"
                :title="$t('labels.planningModify')">
                <info-planning
                    ref="tabPlanning"
                    :editable="true"
                    :journey="journey"
                    :order="dataOrder"
                    @change="handleJourneyChange"
                    @cancel="visiblePlanning = false" />
            </hts-modal>

            <hts-modal
                v-model="visibleTiming"
                size="large"
                type="confirm"
                title="Nhập thời gian"
                :disabled="editTimeEditing"
                :loading="editTimeLoading"
                @confirm="handleUpdateTime">
                <div class="h-10 py-1">
                    <hts-form-toggle
                        v-model="expanded"
                        size="v-mini"
                        color="primary"
                        class="inline-block"
                        label="Tác vụ: Expand/Collapse" />
                </div>
                <hts-travel-details
                    v-if="travelDetails.length"
                    ref="travelRouteEdit"
                    :journey-id="journey._id"
                    :partner-id="journey?.partnerId"
                    :travel-details="travelDetails"
                    :stage-start="stageIndexStart"
                    :stage-end="stageIndexEnd"
                    :start="journey?.travelIndexStart"
                    :end="journey?.travelIndexEnd"
                    :edit-time="true"
                    :start-at="journey?.startAt"
                    :start-at-estimate="journey?.startAtEstimate"
                    :start-at-actual="journey?.startAtActual"
                    :start-at-parking="journey?.startAtParking"
                    :start-at-location="journey?.startAtLocation"
                    :stop-at="journey?.stopAt"
                    :stop-at-estimate="journey?.stopAtEstimate"
                    :stop-at-actual="journey?.stopAtActual"
                    :stop-at-parking="journey?.stopAtParking"
                    :stop-at-location="journey?.stopAtLocation"
                    :travel-index="journey?.travelIndex"
                    :travel-stage-index="journey?.travelStageIndex"
                    direction="horizontal"
                    class="max-h-[400px] overflow-auto"
                    @editing="handleTimeEditing"
                    @update-start-at="handleUpdateJourneyTime($event, 'startAtActual')"
                    @update-stop-at="handleUpdateJourneyTime($event, 'stopAtActual')" />
            </hts-modal>

            <hts-modal
                v-model="visibleChangeVehicle"
                size="large"
                type="confirm"
                :title="changeVehicleTitle"
                :loading="loadingChangeVehicle"
                @confirm="handleChangeVehicle">
                <hts-select-option
                    v-model="changeVehicleForm.mode"
                    class="mb-2"
                    :items="changeVehicleModeOptions"
                    @change="handleChangeVehicleMode" />
                <hts-select-option
                    v-model="changeVehicleForm.type"
                    class="mb-2"
                    :items="changeVehicleTypeOptions"
                    @change="handleChangeVehicleType" />
                <hts-select-cooperator
                    v-if="changeVehicleForm.mode === 'partner'"
                    v-model="changeVehicleForm.partnerId"
                    label="Đội xe"
                    required />
                <hts-select-vehicle
                    ref="changeVehicleSelectVehicle"
                    v-model="changeVehicleForm.vehicleId"
                    :cooperator-id="changeVehicleForm.partnerId"
                    :cooperator-required="changeVehicleForm.mode === 'partner'"
                    label="Xe đổi"
                    required
                    @change="changeVehicle" />
                <hts-form-input
                    v-if="changeVehicleForm.type !== 'journey'"
                    v-model="changeVehicleForm.nodeName"
                    label="Tên vị trí"
                    required />
                <div
                    v-if="changeVehicleForm.mode !== 'partner'"
                    v-loading="changeVehicleLoading"
                    class="mb-5">
                    <hts-form-date
                        v-model="changeVehicleForm.startAt"
                        label="Thời gian khởi hành dự kiến"
                        type="datetime"
                        time-format="HH:mm"
                        name="estimatedDepartureTime"
                        prop="startAt"
                        required
                        confirm />
                    <hts-form-select
                        v-model="changeVehicleForm.startAtLocationId"
                        :items="changeVehicleLocations"
                        name="estimatedDepartureLocation"
                        prop="startAtLocationId"
                        key-id="id"
                        label="Địa điểm khởi hành dự kiến"
                        required />
                </div>
                <hts-map-node
                    v-if="changeVehicleForm.type === 'map'"
                    class="mt-2"
                    :center-position="changeVehicleAndMoocForm.mapPosition"
                    @click="handleClickOnMap" />
                <hts-map-vehicle
                    v-if="changeVehicleForm.type === 'vehicle'"
                    ref="changeVehicleMap"
                    class="mt-2" />
                <template v-if="changeVehicleForm.type === 'journey'">
                    <hts-form-select
                        v-model="changeVehicleForm.stageId"
                        label="Vị trí"
                        :items="travelStagies"
                        key-id="_id"
                        key-label="nodeName"
                        required
                        @change="setStageTasks(changeVehicleForm.stageId)" />
                    <hts-form-select
                        v-model="changeVehicleForm.taskId"
                        label="Tác vụ"
                        :items="stageTasks"
                        key-id="_id"
                        key-label="taskName"
                        required />
                </template>

                <div
                    v-if="changeVehicleErrors.length"
                    class="my-2 text-red-500">
                    <h3>
                        Lỗi:
                    </h3>
                    <template
                        v-for="(error, index) in changeVehicleErrors"
                        :key="index">
                        <div class="mb-1 text-red-500">
                            {{ error }}
                        </div>
                    </template>
                </div>
            </hts-modal>
        </div>

        <hts-modal
            :show="showModalNotFoundRoute"
            size="small"
            @hide="
                () => {
                    showModalNotFoundRoute = false
                }
            ">
            <div>
                <p class="mt-5">
                    Chưa có thông tin tuyến đường trên hệ thống. Vui lòng liên hệ Điều độ để thực hiện vẽ tuyến.
                </p>
            </div>
        </hts-modal>

        <hts-modal
            :show="showModalWarningStatus"
            @hide="
                () => {
                    showModalWarningStatus = false
                }
            ">
            <div>
                <p class="mt-5">
                    Bạn không thể cập nhật tuyến đường do đơn hàng đã được được phân bổ.
                </p>
            </div>
        </hts-modal>

        <hts-modal
            :show="showModalConfirmChangeRoute"
            @hide="
                () => {
                    showModalConfirmChangeRoute = false
                }
            ">
            <div>
                <p class="mt-5">
                    Kế hoạch vận chuyển sẽ được tính toán lại theo tuyến đường mới nhất trên hệ thống. Vui lòng xác nhận nếu bạn muốn muốn tiếp tục?
                </p>

                <div class="flex justify-end mt-5 gap-5">
                    <hts-form-button
                        icon-name="hi-check-icon"
                        icon-position="right"
                        type="button"
                        :outline="false"
                        @click="handleConfirmChangeRoute()">
                        {{ $t('labels.confirm') }}
                    </hts-form-button>
                </div>
            </div>
        </hts-modal>

        <hts-modal
            :show="requiredDocument"
            @hide="
                () => {
                    requiredDocument = false
                }
            ">
            <div>
                <p class="mt-5">
                    {{ requiredDocumentMessage }}
                </p>

                <div class="flex justify-end mt-5 gap-5">
                    <hts-form-button
                        icon-name="hi-check-icon"
                        icon-position="right"
                        type="button"
                        :outline="false"
                        @click="
                            () => {
                                requiredDocument = false
                            }
                        ">
                        {{ $t('labels.confirm') }}
                    </hts-form-button>
                </div>
            </div>
        </hts-modal>
    </div>
</template>

<script setup lang="ts">
import JourneyAlerts from './alerts.vue'
import DriverInfo from './driver-info.vue'
import JourneyFiles from './files.vue'
import InfoPlanning from './planning.vue'
import TravelRouteInfo from './travel-route-info.vue'
import { drawJourneyTracking } from './utils'
import VehicleInfo from './vehicle-info.vue'
import routeMap from '@/pages/trucker-[id]/route/ignore/route-map'

const travelMap = ref<any>(null)
const { markers, setMarkers, routes, setRoutes, setRoutingPositions, showLocation, CLatLngLocationRoutes } = routeMap('monitoringOwner', travelMap.value)
const { map } = $store()

const emits = defineEmits(['modify', 'update-route', 'journey-changed', 'open-timing', 'open-planning', 'journey-time-changed'])
const props = defineProps({
  journey: {
    type: Object,
    required: true
  },
  findRoute: {
    type: Function
  },
  allocationStatus: {
    type: Number,
    default: 4
  },
  editable: Boolean
})

const { journey, findRoute, allocationStatus } = toRefs(props)

const tracking = computed(() => journey.value?.tracking)
const expectedPaths = computed(() => tracking.value?.expectedPaths)
const last24hPaths = computed(() => tracking.value?.last24hPaths)
const trackingPaths = computed(() => tracking.value?.paths)
const journeyVehicle = computed(() => journey.value?.vehicle || journey.value?.vehicleTemp)
const vehicleLocation = computed(() => journeyVehicle.value?.gpsInfo)
const journeyLoaded = ref(false)
const visiblePlanning = ref(false)
const visibleTiming = ref(false)
const visibleMap = computed(() => map.showMap.monitoringOwner)
const expanded = ref(false)
const startLocation = ref(null)
const stopLocation = ref(null)
const requiredDocument = ref<boolean>(false)
const requiredDocumentMessage = ref<string>('')

const directionColor = computed(() => {
  return '#9D9D9D'
})
const tabs = ref([
  {
    label: 'Cảnh báo',
    key: 'alerts'
  },
  {
    label: 'Tài liệu',
    key: 'files'
  }
])
const tab = ref('alerts')
const dataOrder = computed<any>(() => journey.value?.order || {})
const travelDetails = ref<any[]>([])
const stageIndexStart = computed(() => journey.value?.stageIndexBegin || journey.value?.stageIndexStart)
const stageIndexEnd = computed(() => journey.value?.stageIndexEnd)
const travelIndexStart = computed(() => journey.value?.travelIndexStart)
const travelIndexEnd = computed(() => journey.value?.travelIndexEnd)
const travelStagies = computed(() =>
  travelDetails.value.filter((t: any) => t.type === 'stage' && t.index >= stageIndexStart.value && t.index <= stageIndexEnd.value)
)

const btnFindRoute = ref({
  loading: false
})

const travelRouteEdit = ref<any>(null)
watch(
  () => expanded.value,
  (val: boolean) => {
    toggleExpandCollapse(val)
  }
)
const toggleExpandCollapse = $lodash.debounce((val: boolean) => {
  if (!travelRouteEdit.value) {
    return
  }
  travelRouteEdit.value.toggleExpandCollapse(val)
}, 300)

const showModalNotFoundRoute = ref(false)
const showModalConfirmChangeRoute = ref(false)
const showModalWarningStatus = ref(false)
const route = ref({} as any)

const vehicle = computed(() => journey.value?.vehicle || journey.value?.vehicleTemp)
const driver = computed(() => vehicle.value?.otherCompanyDriver || vehicle.value?.driver)
const coDriver = computed(() => vehicle.value?.otherCompanyCoDriver || vehicle.value?.coDriver)
const cDriver = computed(() => {
  if (coDriver.value) {
    return [driver.value, coDriver.value]
  }

  return [driver.value]
})

const show = (journeyData: any) => {
  if (!journeyData) {
    return
  }
  travelDetails.value = $lodash.cloneDeep(journeyData?.travelDetails)

  nextTick(async () => {
    await setMapData(journeyData)
    nextTick(() => {
      journeyLoaded.value = true
      nextTick(() => {
        drawJourneyTracking(travelMap.value, journeyData)
      })
    })
  })
}

const setMapData = (journeyData: any, trip: boolean = false) => {
  if (journeyData?.routingPositions) {
    let positionsAndWaitingTasks = $lodash.cloneDeep(journeyData.positionsAndWaitingTasks || [])
    if (!trip) {
      positionsAndWaitingTasks = positionsAndWaitingTasks.slice(journeyData.stageIndexBegin, journeyData.stageIndexEnd + 1)
    }
    const firstPosition = positionsAndWaitingTasks[0] || null
    const lastPosition = positionsAndWaitingTasks[positionsAndWaitingTasks.length - 1] || null

    if (trip) {
      startLocation.value = null
      stopLocation.value = null
    } else {
      if (journeyData?.startAtLocation) {
        startLocation.value = journeyData?.startAtLocation
        positionsAndWaitingTasks.unshift(journeyData?.startAtLocation)
      } else if (lastPosition) {
        startLocation.value = firstPosition
      }
      if (journeyData?.stopAtLocation) {
        if (lastPosition && (lastPosition.lat !== journeyData?.stopAtLocation.lat || lastPosition.lng !== journeyData?.stopAtLocation.lng)) {
          stopLocation.value = journeyData?.stopAtLocation
          positionsAndWaitingTasks.push(journeyData?.stopAtLocation)
        }
      } else if (lastPosition) {
        stopLocation.value = lastPosition
      }
    }

    setRoutingPositions(journeyData?.routingPositions)
    setMarkers(positionsAndWaitingTasks, { renderMarkerByIndexNumber: trip })
    setRoutes(positionsAndWaitingTasks)
  }
}

const handleFindRoute = async () => {
  btnFindRoute.value.loading = true
  if (!findRoute?.value) {
    btnFindRoute.value.loading = false
    return
  }

  if (allocationStatus.value === 5 || allocationStatus.value === 6) {
    btnFindRoute.value.loading = false
    showModalWarningStatus.value = true
    return
  }

  route.value = await findRoute.value({ modules: ['ROUTE'] })

  if (!route.value) {
    showModalNotFoundRoute.value = true
  } else {
    showModalConfirmChangeRoute.value = true
  }
  btnFindRoute.value.loading = false
}

const handleConfirmChangeRoute = () => {
  showModalConfirmChangeRoute.value = false
  emits('update-route', route.value)
}

const openPlanning = (e: any) => {
  emits('open-planning', e)
  visiblePlanning.value = true
}
const openTiming = (e: any) => {
  emits('open-timing', e)
  visibleTiming.value = true
}

const journeyAlertRef = ref<any>(null)
const journeyFileRef = ref<any>(null)
const handleJourneyChange = () => {
  emits('journey-changed')
  if (journeyAlertRef.value) {
    journeyAlertRef.value.refresh()
  }
  if (journeyFileRef.value) {
    journeyFileRef.value.refresh()
  }
  visiblePlanning.value = false
}

const editTimeEditing = ref(false)
const editTimeLoading = ref(false)
const handleUpdateTime = async () => {
  if (await travelRouteEdit.value.validate()) {
    return
  }
  const updateArr: any[] = []
  editTimeLoading.value = true
  travelDetails.value.forEach((item: any, i: number) => {
    if (!item.ata && !item.atd) {
      return
    }
    if (item.type === 'stage') {
      if (item.index >= stageIndexStart.value && item.index <= stageIndexEnd.value) {
        updateArr.push({
          _id: item._id,
          ata: item.ata,
          atd: item.atd
        })
      }
      return
    }
    if (item.type === 'task') {
      if (i >= travelIndexStart.value && i <= travelIndexEnd.value) {
        updateArr.push({
          _id: item._id,
          ata: item.ata,
          atd: item.atd
        })
      }
    }
  })

  $api($urlPartner.monitoring.journey?.setActualTimeMultiple, {
    uriParams: { ID: journey?.value._id },
    body: { startAt: journey?.value.startAtActual, stopAt: journey?.value.stopAtActual, updateArr }
  })
    .then((data: any) => {
      const resData: any = data?.data?.value
      editTimeLoading.value = false
      if (resData?.success) {
        if (resData.data.requiredDocument) {
          visibleTiming.value = false
          requiredDocument.value = true
          requiredDocumentMessage.value = resData.data.mesage

          return
        }
        visibleTiming.value = false
        process.client && $toast().success($t('labels.updateSuccess'))
        handleJourneyChange()
      }
    })
    .catch(() => {
      editTimeLoading.value = false
    })
}

const stageTasks = ref<any[]>([])
const setStageTasks = (stageId: string) => {
  const stage = travelDetails.value.find((t: any) => t._id === stageId)
  if (!stage) {
    stageTasks.value = []
    return
  }
  stageTasks.value = travelDetails.value.filter(
    (t: any, i: number) => t.type === 'task' && t.stageIndex === stage.stageIndex && i >= travelIndexStart.value && i <= travelIndexEnd.value
  )
}
const visibleChangeVehicle = ref(false)
const loadingChangeVehicle = ref(false)
const changeVehicleTitle = ref('Đổi xe')
const changeVehicleForm = reactive<any>({
  separatedType: 'only_head',
  mode: 'internal',
  type: 'journey',
  mapPosition: null,
  partnerId: null,
  vehicleId: null,
  nodeName: '',
  stageId: '',
  taskId: '',
  startAt: '',
  startAtLocationId: null
})
const changeVehicleLocations = ref([])
const changeVehicleTypeOptions = ref([
  { name: 'Vị trí trong chặng', value: 'journey' },
  { name: 'Vị trí trên bản đồ', value: 'map' },
  { name: 'Vị trí hiện tại của xe', value: 'vehicle' }
])
const changeVehicleModeOptions = ref([
  { name: 'Nội bộ', value: 'internal' },
  { name: 'Đội xe ngoài', value: 'partner' }
])
watch(
  () => changeVehicleForm.mapPosition,
  () => {
    handleChangeVehicleValidate()
  }
)
const openChangeVehicle = () => {
  changeVehicleTitle.value = 'Cắt Mooc'
  changeVehicleForm.separatedType = 'only_head'
  visibleChangeVehicle.value = true
}
const changeVehicleErrors = ref<any[]>([])
const handleChangeVehicle = () => {
  if (changeVehicleErrors.value.length) {
    return
  }
  if (!vehicle.value) {
    process.client && $toast().error('Chặng chưa có xe')
    return
  }

  loadingChangeVehicle.value = true
  $api($urlPartner.monitoring.journey?.changeVehicle, { uriParams: { ID: journey?.value._id }, body: changeVehicleForm }).then(({ data }: any) => {
    const { success } = data?.value || {}
    loadingChangeVehicle.value = false
    if (success) {
      visibleChangeVehicle.value = false
      process.client && $toast().success('Đổi thành công')
      emits('journey-changed')
    }
  })
}
const changeVehicleSelectVehicle = ref<any>(null)
const handleChangeVehicleMode = () => {
  changeVehicleForm.vehicleId = null
  changeVehicleForm.partnerId = null
  changeVehicleSelectVehicle.value?.handleClear()
}
const changeVehicleMap = ref<any>(null)
const handleChangeVehicleType = () => {
  handleChangeVehicleValidate()
}
const handleChangeVehicleValidate = () => {
  changeVehicleErrors.value = []
  switch (changeVehicleForm.type) {
  case 'vehicle':
    if (!journey.value?.vehicle?.gpsInfo) {
      changeVehicleErrors.value.push('Vị trí của xe không hợp lệ')
    } else {
      changeVehicleMap.value?.ready().then(() => {
        changeVehicleMap.value?.showVehicle(journey.value?.vehicle?._id)
      })
    }
    break
  case 'map':
    if (!changeVehicleForm.mapPosition) {
      changeVehicleErrors.value.push('Vị trí của xe không hợp lệ')
    }
    break
  default:
  }
}
const handleClickOnMap = (position: any) => {
  changeVehicleForm.mapPosition = position
}

// const visibleChangeVehicleAndMooc = ref(false)
// const loadingChangeVehicleAndMooc = ref(false)

const changeVehicleAndMoocForm = reactive<any>({
  mode: 'internal',
  type: 'journey',
  mapPosition: null,
  partnerId: null,
  vehicleId: null,
  nodeName: '',
  stageId: '',
  taskId: '',
  startAt: '',
  startAtLocationId: null
})
const changeVehicleAndMoocLocations = ref([])
watch(
  () => changeVehicleAndMoocForm.mapPosition,
  () => {
    handleChangeVehicleAndMoocValidate()
  }
)
const changeVehicleAndMoocRules = reactive({
  travelId: 'required',
  taskId: 'required',
  vehicleId: 'required'
})
const changeVehicleAndMoocErrors = ref<any[]>([])
const changeVehicleAndMoocRef = ref<any>(null)
const openChangeVehicleAndMooc = () => {
  changeVehicleTitle.value = 'Đổi xe'
  changeVehicleForm.separatedType = 'all'
  visibleChangeVehicle.value = true
}
const handleChangeVehicleAndMooc = () => {
  if (changeVehicleAndMoocErrors.value.length) {
    return
  }
  loadingChangeVehicle.value = true

  $api($urlPartner.monitoring.journey?.changeVehicleAndMooc, { uriParams: { ID: journey?.value._id }, body: changeVehicleAndMoocForm }).then(
    ({ data }: any) => {
      const { success } = data?.value || {}
      loadingChangeVehicle.value = false
      if (success) {
        visibleChangeVehicle.value = false
        process.client && $toast().success('Đổi thành công')
        emits('journey-changed')
      }
    }
  )
}
const handleClickOnMapVehicleAndMooc = (position: any) => {
  changeVehicleAndMoocForm.mapPosition = position
}
const changeVehicleAndMoocSelectVehicle = ref<any>(null)
const handleChangeVehicleAndMoocMode = () => {
  changeVehicleAndMoocForm.vehicleId = null
  changeVehicleAndMoocForm.partnerId = null
  changeVehicleAndMoocSelectVehicle.value?.handleClear()
}
const changeVehicleAndMoocMap = ref<any>(null)
const handleChangeVehicleAndMoocType = () => {
  handleChangeVehicleAndMoocValidate()
}
const handleChangeVehicleAndMoocValidate = () => {
  changeVehicleAndMoocErrors.value = []
  switch (changeVehicleAndMoocForm.type) {
  case 'vehicle':
    if (!journey.value?.vehicle?.gpsInfo) {
      changeVehicleAndMoocErrors.value.push('Vị trí của xe không hợp lệ')
    } else {
      changeVehicleAndMoocMap.value?.ready().then(() => {
        changeVehicleAndMoocMap.value?.showVehicle(journey.value?.vehicle?._id)
      })
    }
    break
  case 'map':
    if (!changeVehicleAndMoocForm.mapPosition) {
      changeVehicleAndMoocErrors.value.push('Vị trí của xe không hợp lệ')
    }
    break
  default:
  }
}

const changeVehicleLoading = ref(false)
const changeVehicle = () => {
  changeVehicleLocations.value = []
  changeVehicleLoading.value = true
  $api($urlPartner.journey.schedule.getLocations, {
    query: {
      vehicleId: changeVehicleForm.vehicleId,
      timeIn: 0,
      timeOut: 0
    }
  }).then(({ data }) => {
    const tmp = data.value || {}
    changeVehicleLocations.value = tmp.data || []
    changeVehicleLoading.value = false
  })
}
const changeVehicleAndMoocLoading = ref(false)
const changeVehicleAndMooc = () => {
  changeVehicleLocations.value = []
  changeVehicleAndMoocLoading.value = true
  $api($urlPartner.journey.schedule.getLocations, {
    query: {
      vehicleId: changeVehicleAndMoocForm.vehicleId,
      timeIn: 0,
      timeOut: 0
    }
  }).then(({ data }) => {
    const tmp = data.value || {}
    changeVehicleAndMoocLocations.value = tmp.data || []
    changeVehicleAndMoocLoading.value = false
  })
}

const handleUpdateJourneyTime = (val: any, key: string) => {
  handleTimeEditing()
  journey.value[key] = val
}

let editingTimeout: any = null
const handleTimeEditing = async () => {
  editTimeEditing.value = true
  if (editingTimeout) {
    clearTimeout(editingTimeout)
  }
  await new Promise((resolve: any) => {
    editingTimeout = setTimeout(() => {
      editTimeEditing.value = false
      resolve(true)
    }, 500)
  })
}

const handlShowTrip = (val: boolean) => {
  setMapData(journey.value, val)
}

defineExpose({
  show,
  close
})
</script>
